module.exports = __webpack_public_path__ + "img/mode2-3.524cc39b.png";